import { useCallback, useEffect, useRef, useState } from "react";
import { BrowserSpeechInput, browserSpeechConstructor } from "./browserSpeechInput";

export function useBrowserSpeechInput({ disabled = false, onTranscript }: { disabled?: boolean; onTranscript: (text: string) => void }) {
  const controller = useRef<BrowserSpeechInput | null>(null);
  const callback = useRef(onTranscript);
  const acknowledged = useRef(false);
  const [isListening, setIsListening] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => { callback.current = onTranscript; }, [onTranscript]);
  const stop = useCallback(() => {
    controller.current?.stop();
    controller.current = null;
  }, []);
  useEffect(() => {
    if (disabled) stop();
    return stop;
  }, [disabled, stop]);
  const toggle = useCallback(() => {
    if (disabled) return;
    if (controller.current) { stop(); setMessage("语音输入已停止"); return; }
    const Constructor = browserSpeechConstructor();
    if (!Constructor) { setMessage("当前浏览器不支持语音识别，请使用键盘输入，或换用支持的浏览器。"); return; }
    if (!acknowledged.current) {
      if (!window.confirm("语音识别由浏览器提供，可能联网处理你的语音。Merry 不保存或上传音频。是否开始语音输入？")) return;
      acknowledged.current = true;
    }
    setMessage("正在聆听，点击麦克风可停止");
    try {
      const next = new BrowserSpeechInput(new Constructor(), {
        onFinal: (text) => { callback.current(text); setMessage("识别文字已加入输入框，不会自动发送"); },
        onEnd: () => { controller.current = null; setIsListening(false); },
        onError: setMessage,
      });
      controller.current = next;
      setIsListening(true);
      next.start();
    } catch {
      stop();
      setIsListening(false);
      setMessage("无法启动语音识别，请检查浏览器权限后重试。");
    }
  }, [disabled, stop]);
  return { isListening, message, stop, toggle };
}
